

export class User {
    id: number = 1;
    name: string = 'Usuario';
    image?: string ;
    status: string = 'online';
    messages: Message[] = [];
    lastSeen: string = 'online';
}
export interface Message {
    text: string;
    ownerId: number,
    createdAt: number;
}